import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toggle-container"
}
const _hoisted_2 = ["aria-pressed", "value", "onClick"]
const _hoisted_3 = { class: "toggle-btn-label" }

import { IDropdownItem } from '@/interfaces';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
    context: {}
  },
  setup(__props: any) {

const props = __props;

const options = computed(() => (props?.context?.options as IDropdownItem[]) ?? []);

function emitChange(value: string) {
  props.context?.node.input(value);
}

if (props?.context?.defaultOption && props.context?.node?.value == undefined) {
  emitChange(props?.context?.defaultOption);
}

return (_ctx: any,_cache: any) => {
  return (options.value?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: _normalizeClass(["toggle-btn aria-pressed:border-[1.5px] aria-pressed:border-racq-navy", props.context?.node?.value == option.value ? 'toggle-btn-active' : '']),
            "aria-pressed": props.context?.node?.value == option.value,
            type: "button",
            role: "button",
            value: option.value,
            onClick: () => emitChange(option.value)
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1)
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})